// Hook - statystyki pipeline (deale aktywne) handlowca per stage.
// GET /api/ui/trader-management/traders/{traderId}/pipeline

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IGetTraderPipelineResponse } from 'api/types/traderManagement';

const getTraderManagementPipeline = (traderId: number): Promise<IGetTraderPipelineResponse> =>
  axios.get(`/trader-management/traders/${traderId}/pipeline`);

export const useGetTraderManagementPipeline = (
  traderId: number,
  options?: UseQueryOptions<IGetTraderPipelineResponse, IError>
) =>
  useQuery<IGetTraderPipelineResponse, IError>(
    ['trader-management-pipeline', traderId],
    () => getTraderManagementPipeline(traderId),
    { enabled: traderId > 0, ...(options ?? {}) }
  );
